import { Injectable } from '@angular/core';
import {
  Firestore,
  collection,
  doc,
  query,
  where,
  collectionData,
  docData
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Action } from 'src/app/models/action';

@Injectable({
  providedIn: 'root'
})
export class ActionService {

  constructor(private firestore: Firestore) {}

  getActionById(id: string): Observable<Action> {
    const actionRef = doc(this.firestore, `actions/${id}`);
    return docData(actionRef, { idField: 'id' }) as Observable<Action>;
  }

  getActionByProcess(process: string): Observable<Action[]> {
    const actionsRef = collection(this.firestore, 'actions');
    const q = query(actionsRef, where('process', '==', process));
    return collectionData(q, { idField: 'id' }) as Observable<Action[]>;
  }
}
